import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 标记
 */
class Label extends UltMeta {
    LOADED = new Meta(1, "已装载");
    IDLE = new Meta(2, "空载");
    WORKING = new Meta(3, "正在装卸");
    UNKNOWN = new Meta(4, "无法确定");
}
export const LABEL = new Label();

/**
 * 识别结果
 */
class RecognizeResult extends UltMeta {
    WORKING = new Meta(1, "装卸中");
    LOADED = new Meta(2, "装载");
    IDLE = new Meta(3, "空载");
    UNKNOWN = new Meta(4, "未知");
}
export const RECONIZE_RESULT = new RecognizeResult();

/**
 * 状态
 */
class DataSetStatus extends UltMeta {
    UNLABELED = new Meta(1, "未标记");
    LABELED = new Meta(2, "已经标记");
    PUBLISHED = new Meta(3, "已经发布");
}
export const DATA_SET_STATUS = new DataSetStatus();

/**
 * 识别记录状态
 */
class RecognizeRecordStatus extends UltMeta {
    NOT_ADDED = new Meta(1, "未加入");
    ADDED = new Meta(2, "已加入");
}
export const RECONIZE_RECORD_STATUS = new RecognizeRecordStatus();
